import { MessageOperation, RequestOperation } from '@peercolab/engine'
import { SearchInput } from '../../Core/PathItems'
import { Published } from '../Core/PathItems'

export class CreateInsuranceProvider extends RequestOperation<CreateInsuranceProviderInput,InsuranceProvider> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.InsuranceProviders.CreateInsuranceProvider",
      "CREATE",
      ["InsuranceProviderId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class SearchInsuranceProvider extends RequestOperation<SearchInput,InsuranceProvider[]> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.InsuranceProviders.SearchInsuranceProvider",
      "SEARCH",
      ["InsuranceProviderId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class GetInsuranceProvider extends RequestOperation<object,InsuranceProvider> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.InsuranceProviders.GetInsuranceProvider",
      "GET",
      ["InsuranceProviderId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class DeleteInsuranceProvider extends MessageOperation<object> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.InsuranceProviders.DeleteInsuranceProvider",
      "DELETE",
      ["InsuranceProviderId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateInsuranceProviderName extends MessageOperation<UpdateInsuranceProviderNameInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.InsuranceProviders.UpdateInsuranceProviderName",
      "PATCH",
      ["InsuranceProviderId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateInsuranceProviderState extends MessageOperation<UpdateInsuranceProviderStateInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.InsuranceProviders.UpdateInsuranceProviderState",
      "PATCH",
      ["InsuranceProviderId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export type CreateInsuranceProviderInput = {
  insuranceProviderId?: string | undefined
  name: string
}

export type InsuranceProvider = {
  id: string
  name: string
  state: Published
}

export type UpdateInsuranceProviderNameInput = {
  name: string
}

export type UpdateInsuranceProviderStateInput = {
  /**
   * Valid values: publish, unpublish, revert
   */
  stateTransition: string
}

